import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'formattedTileDataForTileType' })
export class FormattedForTileType implements PipeTransform {
  transform(rawValue: number, tileType: string): string | number {
    switch (tileType) {
      case 'Percent':
        return `${(rawValue * 100).toFixed(0)}%`;
      default:
        return rawValue;
    }
  }
}
